.link {
  font-family: var(--ism-typeface-bold);
  color: inherit;
  text-decoration: none;
}
